module.exports = "<svg viewBox=\"0 0 16.8 16.8\"><path fill=\"#231F20\" d=\"M16 16.8H.8c-.4 0-.8-.4-.8-.8V.8C0 .4.4 0 .8 0H16c.4 0 .8.3.8.8V16c0 .4-.4.8-.8.8zM1.6 15.2h13.7V1.6H1.6v13.6z\"></path><path fill=\"#231F20\" d=\"M8.4 13.4c-2.6 0-4.7-2.1-4.7-4.7S5.8 4 8.4 4s4.7 2.1 4.7 4.7-2.1 4.7-4.7 4.7zm0-7.8C6.7 5.6 5.3 7 5.3 8.7c0 1.7 1.4 3.1 3.1 3.1s3.1-1.4 3.1-3.1c0-1.7-1.4-3.1-3.1-3.1z\"></path><circle cx=\"13\" cy=\"4.1\" r=\".8\" fill=\"#231F20\"></circle></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/instagram.svg
// module id = 304
// module chunks = 1